import { render } from "./refer_details.vue?vue&type=template&id=466e8216&scoped=true"
import script from "./refer_details.vue?vue&type=script&lang=js"
export * from "./refer_details.vue?vue&type=script&lang=js"

import "./refer_details.vue?vue&type=style&index=0&id=466e8216&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466e8216"]])

export default __exports__